import { HttpResponse, SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { GetOrganizerResponse, ICategorization, IConvertDateTimeToUTCReq, IConvertDateTimeToUTCResp, IGetApptInfoFromItemId, IICalUidExternal, OrganizationInfo } from "./entity/OrganizationEntity";
import { HttpClientNormal } from "@/fetchInterceptor/HttpClient";
import { AxiosResponse } from "axios";
import { IOrganizationService } from "./IOrganizationService";
import { IOutlookOrganizerRepository, TokenIOutlookOrganizerRepository } from "@/out-look/interfaces/IOutlookOrganizerRepository";
import { baContainer } from "@/ioc/RegisterRFServices";
import { config } from "../../config";
import axios from "axios";
// import { IMeetingInfo } from "@/common/entity/Entity";

export class OrganizationService implements IOrganizationService {
  private http: HttpClientNormal = new HttpClientNormal();
  private _olOrganizerRepository: IOutlookOrganizerRepository;
  public constructor() {
    this._olOrganizerRepository = baContainer.resolve(TokenIOutlookOrganizerRepository);
  }

  fetchOrgInfo(): Promise<HttpResponse<OrganizationInfo>> {
    const url = `${config.API_URL}/Organization`;
    return this.http
      .get(url)
      .then((response: AxiosResponse) => new HttpResponse<OrganizationInfo>(response, OrganizationInfo))
      .catch((error) => new HttpResponse<OrganizationInfo>(error?.response, OrganizationInfo));
  }

  fetchCategorization(tenantId: string, orgId: string): Promise<HttpResponse<ICategorization>> {
    const url = `${config.API_URL}/${tenantId}/categorization/${orgId}`;

    return this.http
      .get(url)
      .then((response: AxiosResponse) => new HttpResponse<ICategorization>(response))
      .catch((error) => new HttpResponse<ICategorization>(error?.response));
  }

  async GetCurrentOrganizer(org?: OrganizationInfo | null): Promise<GetOrganizerResponse | undefined> {
    let organizer: GetOrganizerResponse | undefined;
    const olOrg = this._olOrganizerRepository.GetOrganizer();
    const olOrgReal = await this._olOrganizerRepository.GetRealOrganizerOfAppointment();

    if (olOrg) {
      organizer = {
        Email: olOrgReal ? olOrgReal.Email : olOrg.Email,
        Name: olOrgReal ? olOrgReal.Name : olOrg.DisplayName,
        TimeZoneStandardName: olOrg.TimeZoneName,
        OrgInfo: org || null,
      };
    }
    return organizer;
  }

  GetCurrentOutlookUser(): GetOrganizerResponse | undefined {
    let organizer: GetOrganizerResponse | undefined;
    const olOrg = this._olOrganizerRepository.GetOrganizer();
    if (olOrg) {
      organizer = {
        Email: olOrg.Email,
        Name: olOrg.DisplayName,
        TimeZoneStandardName: olOrg.TimeZoneName,
      };
    }
    return organizer;
  }

  getAppInfoByItemId(url: string, accessToken: string): Promise<HttpResponse<IGetApptInfoFromItemId>> {
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(res => new HttpResponse<IGetApptInfoFromItemId>(res))
    .catch(err => {
      console.log("err?.response", err?.response);
      return new HttpResponse<IGetApptInfoFromItemId>(err?.response)
    })
  }

  getICalUidExternal(tenantId: string, orgId: string, uid: string): Promise<SearchResponse<IICalUidExternal>> {
    const url = `${config.API_URL}/${tenantId}/odata/ExternalBooking('${orgId}')/GetICalUidsByUIdExternal`;
    const req = {UIdExternal: uid}
    return this.http
      .post(url, req)
      .then((response: AxiosResponse) => new SearchResponse<IICalUidExternal>(response, undefined, true))
      .catch((error) => new SearchResponse(error?.response));
  }

  convertDateTimeToUTC(req: IConvertDateTimeToUTCReq): Promise<HttpResponse<IConvertDateTimeToUTCResp>> {
    const url = `${config.API_URL}/root/GetMeetingInfosByTimeZone`;
    return this.http
    .post(url, req)
    .then((response: AxiosResponse) => new HttpResponse<IConvertDateTimeToUTCResp>(response))
    .catch((error) => new HttpResponse(error?.response));
  }
}
